export const ADMIN_API = "SecretsStoreSecret::admin_api";
